<template>
  <Head :title="__('download.meta.title')">
    <meta
      name="description"
      :content="__('download.meta.description', {vip: shoutOutAi.vip.content.display_name})"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.shout-out-ai.download', [shoutOutAi])"
    >
    <meta
      property="og:title"
      :content="__('download.meta.title')"
    >
    <meta
      property="og:description"
      :content="__('download.meta.description', {vip: shoutOutAi.vip.content.display_name})"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <div>
    <section class="download relative">
      <img
        src="/frontend/assets/desktop-hero-swirl.svg"
        class="absolute top-0 left-0 hidden lg:block"
      >

      <div class="container relative z-10">
        <div class="pt-7 pb-4 md:hidden">
          <h1 class="text-2xl font-bold text-center sparkle-left ">
            {{ __('download.title') }}<br>
            {{ __('download.from', {vip: shoutOutAi.vip.content.display_name}) }}
          </h1>
        </div>

        <div class="bg-white p-6 rounded-lg grid grid-cols-1 md:grid-cols-5 md:gap-8 lg:gap-16 md:bg-red-100 md:p-0 md:mt-10">
          <div class="md:col-span-3">
            <div class="grid justify-items-center">
              <div
                v-if="shoutOutAi.video"
                class="pb-5 md:shadow-vip-desktop rounded-xl overflow-hidden md:pb-0"
              >
                <video
                  controls
                  class="max-h-[460px] md:max-h-[720px]"
                >
                  <source
                    :src="shoutOutAi.video.url"
                    type="video/mp4"
                  >
                  {{ __('components.video-player.not-supported') }}
                </video>
              </div>
            </div>
          </div>

          <div class="md:col-span-2 md:flex md:content-center md:flex-wrap">
            <h1 class="hidden text-4xl font-bold md:block w-full md:text-left mb-4 pb-4 border-b border-black">
              {{ __('download.title') }}<br>
              {{ __('download.from', {vip: shoutOutAi.vip.content.display_name}) }} (AI avatar)
            </h1>
            <p class="font-medium w-full md:left-text">
              Deze ShoutOut heeft {{ shoutOutAi.vip.first_name }} gemaakt namens {{ shoutOutAi.name }}.
            </p>

            <div class="w-full lg:text-center lg:w-3/5">
              <button
                type="button"
                class="button-green shadow-button-black w-full block lg:inline-block "
                @click="share"
              >
                {{ __('download.share') }}
                <img
                  src="/frontend/assets/share.svg"
                  class="inline ml-2"
                >
              </button>

              <a
                v-if="shoutOutAi.video"
                :href="localeRoute('frontend.shout-out-ai.download-video', [shoutOutAi.uuid])"
                class="button-white-outline shadow-button-red-sec mt-8 w-full block lg:inline-block md:mt-4"
                target="_blank"
              >
                {{ __('download.download') }}
                <img
                  src="/frontend/assets/download.svg"
                  class="inline ml-2"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DefaultWithoutFooter from '../../../Layout/DefaultWithoutFooter.vue';

export default {
  layout: DefaultWithoutFooter,

  props: {
    shoutOutAi: {
      type: Object,
      required: true,
    },
  },

  methods: {
    share() {
      if (navigator.share) {
        navigator.share({
          title: this.__('download.meta.description', {vip: this.shoutOutAi.vip.content.display_name}),
          url: window.location,
        });

        return;
      }

      // @todo implement fallback
    },
  },
};
</script>
